import { Component, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DashboardPanel } from 'src/app/models/dashboard-panel';

@Component({
    templateUrl: './graphics-modal.html',
    standalone: false
})
export class GraphicsModalComponent implements OnDestroy {
  // Listas
  panels: DashboardPanel[] = [];
  // Paineis Colapsáveis
  collPnNavBarCharts: any[] = [];

  constructor(public dialogRef: MatDialogRef<GraphicsModalComponent>, @Inject(MAT_DIALOG_DATA) data: any) {
    // Carregar paineis
    this.panels = data.panels;
  }

  ngOnDestroy() { }
}
